import { isMobileDevice } from './browserAndDevice';
import { isInWebView } from './nativeWebview';

export const BARCODE_SCAN_ANALYTICS_EVENT = '[BARCODE SCAN] Analytics Event';

export const BARCODE_SCAN_EVENTS = {
  MODAL_OPENED: 'barcode_scan_modal_opened',
  SUCCESS: 'barcode_scan_success',
  FAILED: 'barcode_scan_failed',
  DESKTOP_SUCCESS: 'barcode_scan_desktop_success',
  DESKTOP_FAILED: 'barcode_scan_desktop_failed',
};

// Scandit DataCaptureContext status codes reported as `error_code`.
export const SCANDIT_ERROR_CODES = {
  LICENSE_KEY_EXPIRED: 131674,
};

export const getApplicationIdentifier = () =>
  isInWebView() || isMobileDevice()
    ? 'TxT Mobile Web Application'
    : 'TxT Web Application';

// Sent to GA by AnalyticsMiddleware via `meta.gtag`.
export const trackBarcodeScanEvent = (eventName, { errorCode } = {}) => dispatch => {
  dispatch({
    type: BARCODE_SCAN_ANALYTICS_EVENT,
    meta: {
      gtag: {
        name: eventName,
        params: {
          application_identifier: getApplicationIdentifier(),
          ...(errorCode !== undefined && { error_code: errorCode }),
        },
      },
    },
  });
};
